import { render, staticRenderFns } from "./SmsReturnToSite.vue?vue&type=template&id=01cf1cfc"
import script from "./SmsReturnToSite.vue?vue&type=script&lang=js"
export * from "./SmsReturnToSite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports